import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { injectIntl } from 'react-intl';

const LinkedInModal = ({ open, onClose, intl }) => {
    const handleFollowLinkedIn = () => {
        window.open('https://www.linkedin.com/company/breedj/posts', '_blank');
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="linkedin-dialog-title"
            aria-describedby="linkedin-dialog-description"
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle className="text-center text-secondary font-semibold">
                {intl.formatMessage({ id: 'linkedin.modal.title' })}
            </DialogTitle>
            <DialogContent className="text-center">
                <p className="text-gray-600">
                    {intl.formatMessage({ id: 'linkedin.modal.message' })}
                </p>
            </DialogContent>
            <DialogActions className="flex flex-col md:flex-row md:justify-center gap-2 md:space-x-4 pb-6">
                <button
                    onClick={onClose}
                    className="px-8 py-2 text-secondary border-2 border-secondary rounded-full hover:bg-gray-50 w-3/4 md:w-fit"
                >
                    {intl.formatMessage({ id: 'cancel' })}
                </button>
                <button
                    onClick={handleFollowLinkedIn}
                    className="px-8 py-2 bg-secondary text-white rounded-full hover:bg-secondary-dark w-3/4 md:w-fit"
                >
                    {intl.formatMessage({ id: 'linkedin.modal.button' })}
                </button>
            </DialogActions>
        </Dialog>
    );
};

export default injectIntl(LinkedInModal); 